import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }

import { ref } from 'vue';
import { useStore } from 'vuex';
import { app } from '@/guiide/ts/app';
import ConsentInfo from '@/guiide/ts/consent/consentInfo';
import LockButton from '../common/LockButton.vue';
import DynamicAdviceViewer from '../common/DynamicAdviceViewer.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsentCapture',
  props: {
    info: { type: ConsentInfo, required: true }
},
  emits: ["finished"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const errorMessage = ref("");

function onNoClicked() {
    const config = store.state.configuration;
    window.location.href = config.anonRedirect;
}

async function onYesClicked() {
    errorMessage.value = "";

    const result = await app.grantConsent(props.info.permittedEntityType, props.info.externalAgency, props.info.consentType, true);

    if (result.successful) {
        emit("finished");
        return;
    } else {
        errorMessage.value = result.message;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" Welcome to Guiide. We need to confirm your consent to share the data you enter with ")),
      _createElementVNode("strong", null, _toDisplayString(__props.info.companyFullName), 1),
      _createTextVNode(". This sharing is essential for " + _toDisplayString(__props.info.companyAbbrevName) + " to provide you with the best possible service. ", 1)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("p", null, "By proceeding, you agree to the following:", -1)),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("p", null, [
          _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Data Sharing:", -1)),
          _createTextVNode(" The information you provide in our system will be shared with " + _toDisplayString(__props.info.companyAbbrevName) + " for the purpose of managing your account.", 1)
        ])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Privacy and Security:", -1)),
          _cache[3] || (_cache[3] = _createTextVNode(" Your data will be handled in accordance with our ")),
          _cache[4] || (_cache[4] = _createElementVNode("a", {
            href: "https://www.guiide.co.uk/home/privacypolicy",
            target: "_blank"
          }, "privacy policy", -1)),
          _createTextVNode(" and " + _toDisplayString(__props.info.companyAbbrevName) + "'s privacy policy, ensuring it is protected and used responsibly. ", 1)
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("p", null, "Do you consent to share your data?", -1)),
    _createVNode(DynamicAdviceViewer, { message: errorMessage.value }, null, 8, ["message"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LockButton, {
        text: "Yes",
        "async-action": onYesClicked
      }),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary text-decoration-none me-md-2",
        "aria-label": "No",
        onClick: onNoClicked
      }, " No ")
    ])
  ], 64))
}
}

})